import { render, staticRenderFns } from "./RequestPassword.vue?vue&type=template&id=273dbb96&scoped=true&"
import script from "./RequestPassword.vue?vue&type=script&lang=js&"
export * from "./RequestPassword.vue?vue&type=script&lang=js&"
import style0 from "./RequestPassword.vue?vue&type=style&index=0&id=273dbb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273dbb96",
  null
  
)

export default component.exports